<div class="wrapper">
  <!-- Componente de Sidebar -->
  <!-- End Componente de Sidebar -->
  <div>
    <!-- Componente de Navbar -->
    <app-navbar-auth></app-navbar-auth>
    <!-- End Componente de Navbar -->

    <div class="content-wrapper">
      <!-- Content header -->
      <div class="content-header"></div>
      <!-- End Content Header -->

      <!-- Content -->
      <div class="content">
        <app-page-title *ngIf="!hasOwnPageTitle()"></app-page-title>

        <router-outlet></router-outlet>
      </div>
      <!-- End Content -->
    </div>

    <!-- Componente end Footer -->
    <!-- Componente de Footer-->
    <app-footer></app-footer>
  </div>
</div>
